










































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListingDetail } from '@/models/ListingDetail';
import { ParcelDetail } from '@/models/ParcelDetail';
import { Demographics } from '@/models/Demographics';
import EmbeddedLeafletMap from '@/components/EmbeddedLeafletMap.vue';
import ChartDoughnut from '@/components/ChartDoughnut.vue';
import ChartLine from '@/components/ChartLine.vue';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import * as esri from 'esri-leaflet';

@Component({
    components: {
        EmbeddedLeafletMap,
        ChartDoughnut,
        ChartLine,
    },
})
export default class DemographicsPanel extends Vue {

    @Prop(String) public readonly detailType: string | undefined;
    public widthThresholdValue: number = 768;
    public showMap: boolean = false;
    public demoChartTabOptions = ['Population by Age Group', 'Population Projection', 'Education' , 'Marital Status',
                                  'Household Income', 'Ownership', 'Construction Date', 'Children At Home', 'Occupation'];
    public selectedDemographicChartTab = 'Population by Age Group';

    public geoJsonDA: L.GeoJSON | null = null;
    public boundsDA: L.LatLngBounds | null = null;
    public geoJsonPID: L.GeoJSON | null = null;

    public options = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                animateRotate: false,
            },
            legend: {
                position: this.isMobile ? 'bottom' : 'right',
            },
        };

    public lineOptions = {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                animateRotate: false,
            },
            legend: {
                display: false,
            },
        };

    public populationAgeGroup: any = {};
    public populationAgeRangeLabels = ['0 - 4 years old', '5 - 9 years old', '10 - 19 years old', '20 - 34 years old',
                                       '35 - 49 years old', '50 - 54 years old', '55 - 64 years old', '65 - 69 years old',
                                       '70 - 79 years old', '80+ years old'];
    public populationAgeRangeColours = ['#1F77B4', '#E17F0E', '#2CA02C', '#9467BD', '#D62728',
                                        '#8C564B', '#E377C2', '#7F7F7F', '#BCBD22', '#17BECF'];

    public populationProjectionDataCollection: any = {};
    public populationProjectionLabels = ['2016', '2021', '2024', '2026', '2031'];
    public populationProjectionColours = '#1F77B4';

    public educationDataCollection: any = {};
    public educationLabels = ['No Certificate, Diploma Or Degree', 'High School Certificate or Equivalent', 'Apprenticeship or trades cert or diploma',
                              'College, CEGEP, Non-Uni Cert/Diploma', 'Univ. Cert Or Diploma Below Bachelor', 'University Degree',
                              'Bachelor\'s degree', 'Above Bachelor\'s'];
    public educationColours = ['#1F77B4', '#E17F0E', '#2CA02C', '#D62728',
                               '#9467BD', '#8C564B', '#E377C2', '#7F7F7F'];

    public maritalStatusDataCollection: any = {};
    public maritalStatusLabels = ['Married', 'Common Law', 'Single', 'Separated', 'Divorced', 'Widowed'];
    public maritalStatusColours = ['#BCBD22', '#17BECF', '#1F77B4', '#FF7F0E', '#2CA02C', '#D62728'];

    public householdIncomeDataCollection: any = {};
    public householdIncomeLabels = ['$0 - $19,999', '$20,000 - $39,999', '$40,000 - $59,999', '$60,000 - $79,999', '$80,000 - $99,999', '$100,000 - $149,999', '$150,000 - $199,999', '$200,000+'];
    public householdIncomeColours = ['#9467BD', '#8C564B', '#E377C2', '#7F7F7F', '#BCBD22', '#17BECF', '#1F77B4', '#FF7F0E'];

    public ownershipDataCollection: any = {};
    public ownershipLabels = ['Rent', 'Own'];
    public ownershipColours = ['#FF7F0E', '#2CA02C'];

    public constructionDateDataCollection: any = {};
    public constructionDateLabels = ['Before 1960', '1961 - 1980', '1981 - 1990', '1991 - 2000', '2001 - 2005', '2006 - 2011', '2011 - 2016', 'After 2016'];
    public constructionDateColours = ['#D62728', '#9467BD', '#8C564B', '#E377C2', '#7F7F7F', '#BCBD22', '#17BECF', '#1F77B4'];

    public childrenAtHomeDataCollection: any = {};
    public childrenAtHomeLabels = ['0 - 4 Years Old', '5 - 9 Years Old', '10 - 14 Years Old', '15 - 19 Years Old', '20 - 24 Years Old', '25+ Years Old'];
    public childrenAtHomeColours = ['#1F77B4', '#FF7F0E', '#2CA02C', '#D62728', '#9467BD', '#8C564B'];

    public occupationDataCollection: any = {};
    public occupationLabels = ['Not Applicable', 'Management', 'Business, Finance And Administration', 'Natural And Applied Sciences',
                               'Health', 'Education, Law And Social, Community/Gov Services', 'Art, Culture, Recreation And Sport',
                               'Sales And Service', 'Trades, Transport And Equipment Operators', 'Natural Resources, Agriculture',
                               'Manufacturing And Utilities'];
    public occupationColours = ['#E377C2', '#7F7F7F', '#BCBD22', '#17BECF', '#1F77B4', '#FF7F0E', '#2CA02C', '#D62728', '#9467BD', '#8C564B', '#00ff44'];

    get populationAgeRangeData(): any {
        const ageArray = [this.demoData.Pop0to4,
                          this.demoData.Pop5to9,
                          this.demoData.Pop10to14 + this.demoData.Pop15to19,
                          this.demoData.Pop20to24 + this.demoData.Pop25to29 + this.demoData.Pop30to34,
                          this.demoData.Pop35to39 + this.demoData.Pop40to44 + this.demoData.Pop45to49,
                          this.demoData.Pop50to54,
                          this.demoData.Pop55to59 + this.demoData.Pop60to64,
                          this.demoData.Pop65to69,
                          this.demoData.Pop70to74 + this.demoData.Pop75to79,
                          this.demoData.Pop80to84 + this.demoData.Pop85Plus];
        return ageArray;
    }

    get populationProjectionData(): any {
        const populationProjectionArray = [this.demoData.Pop2016,
                                           this.demoData.Pop2021,
                                           this.demoData.Pop2024,
                                           this.demoData.Pop2026,
                                           this.demoData.Pop2031];
        return populationProjectionArray;
    }

    get educationData(): any {
        const educationArray = [this.demoData.EdNoCertDipDeg,
                                this.demoData.EdHighSch,
                                this.demoData.EdAppTradeDip,
                                this.demoData.EdCollege,
                                this.demoData.EdUniBelowBach,
                                this.demoData.EdUniDeg,
                                this.demoData.EdUniBach,
                                this.demoData.EdUniBachPlus];
        return educationArray;
    }

    get maritalStatusData(): any {
        const maritalStatusArray = [this.demoData.StatMarried,
                                    this.demoData.StatCommon,
                                    this.demoData.StatSingle,
                                    this.demoData.StatSeparated,
                                    this.demoData.StatDivorce,
                                    this.demoData.StatWidow];
        return maritalStatusArray;
    }

    get householdIncomeData(): any {
        const householdIncomeArray = [this.demoData.HouseInc0to20,
                                      this.demoData.HouseInc20to40,
                                      this.demoData.HouseInc40to60,
                                      this.demoData.HouseInc60to80,
                                      this.demoData.HouseInc80to100,
                                      this.demoData.HouseInc100to150,
                                      this.demoData.HouseInc150to200,
                                      this.demoData.HouseInc200Plus];
        return householdIncomeArray;
    }

    get ownershipData(): any {
        const ownershipArray = [this.demoData.OwnershipRent,
                                this.demoData.OwnershipOwn];
        return ownershipArray;
    }

    get constructionDateData(): any {
        const ownershipArray = [this.demoData.ContructDatePre1960,
                                this.demoData.ContructDatePre1961to1980,
                                this.demoData.ContructDatePre1981to1990,
                                this.demoData.ContructDatePre1991to2000,
                                this.demoData.ContructDatePre2001to2005,
                                this.demoData.ContructDatePre2006to2011,
                                this.demoData.ContructDatePre2011to2016,
                                this.demoData.ContructDatePre2016Plus];
        return ownershipArray;
    }

    get childrenAtHomeData(): any {
        const childrenAtHomeArray = [this.demoData.ChildHome0to4,
                                     this.demoData.ChildHome5to9,
                                     this.demoData.ChildHome10to14,
                                     this.demoData.ChildHome15to19,
                                     this.demoData.ChildHome20to24,
                                     this.demoData.ChildHome25Plus];
        return childrenAtHomeArray;
    }

    get occupationData(): any {
        const occupationArray = [this.demoData.OccupNA,
                                 this.demoData.OccupMangement,
                                 this.demoData.OccupBusFinAdmin,
                                 this.demoData.OccupNatAppSci,
                                 this.demoData.OccupHealth,
                                 this.demoData.OccupEdLawGov,
                                 this.demoData.OccupArtCultRec,
                                 this.demoData.OccupSaleService,
                                 this.demoData.OccupTradeTrans,
                                 this.demoData.OccupNatResAgri,
                                 this.demoData.OccupMan];
        return occupationArray;
    }

    get isMobile(): boolean {
        return this.$q.screen.width <= this.widthThresholdValue;
    }

    get selectedDetail(): ListingDetail | ParcelDetail | undefined {
        if (this.detailType === 'listing') {
            return this.$store.state.listings.selectedListingDetail;
        } else if (this.detailType === 'parcel') {
            return this.$store.state.parcels.selectedParcelDetail;
        }
    }

    get demoData(): Demographics {
        return this.selectedDetail!.ParcelData!.Demographics!;
    }

    get config() {
        return this.$store.state.config;
    }

    get mobileMapWidth() {
        return (this.$q.screen.width * 0.9).toFixed(0);
    }

    public mounted() {
        if (this.selectedDetail && this.demoData) {
            this.updateMap();
            this.fillData();
        }
    }

    public fillData() {
        this.populationAgeGroup = {
            labels: this.populationAgeRangeLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.populationAgeRangeColours,
                data: this.populationAgeRangeData,
                }],
        };

        this.populationProjectionDataCollection = {
            labels: this.populationProjectionLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.populationProjectionColours,
                data: this.populationProjectionData,
                fill: false,
                borderColor: this.populationProjectionColours,
                borderWidth: 1,
                }],
        };

        this.educationDataCollection = {
            labels: this.educationLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.educationColours,
                data: this.educationData,
                }],
        };

        this.maritalStatusDataCollection = {
            labels: this.maritalStatusLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.maritalStatusColours,
                data: this.maritalStatusData,
                }],
        };

        this.householdIncomeDataCollection = {
            labels: this.householdIncomeLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.householdIncomeColours,
                data: this.householdIncomeData,
                }],
        };

        this.ownershipDataCollection = {
            labels: this.ownershipLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.ownershipColours,
                data: this.ownershipData,
                }],
        };

        this.constructionDateDataCollection = {
            labels: this.constructionDateLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.constructionDateColours,
                data: this.constructionDateData,
                }],
        };

        this.childrenAtHomeDataCollection = {
            labels: this.childrenAtHomeLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.childrenAtHomeColours,
                data: this.childrenAtHomeData,
                }],
        };

        this.occupationDataCollection = {
            labels: this.occupationLabels,
            datasets: [
                {
                label: '',
                backgroundColor: this.occupationColours,
                data: this.occupationData,
                }],
        };
    }

    public updateMap(): void {
        const daQuery = esri.query({
            url: this.config.DALayer.url,
            proxy: this.config.proxy.url,
        });
        daQuery.where('DAUID=' + this.demoData.DAUID).fields('DAUID');
        daQuery.run( (error: any, featureCollection: any) => {
            if (!error && featureCollection.features.length > 0) {
                this.geoJsonDA =  featureCollection;
                this.boundsDA = L.geoJSON(featureCollection).getBounds();
                this.updateParcelLayer();
            }
        });
    }

    public updateParcelLayer(): void {
        const pQuery = esri.query({
            url: this.config.ParcelsLayer.url,
        });

        pQuery.where('PID=\'' + this.selectedDetail!.ParcelData!.PID + '\'').fields('PID');
        pQuery.run( (error: any, featureCollection: any) => {
            if (!error && featureCollection.features.length > 0) {
                this.geoJsonPID = featureCollection;
                this.showMap = true;
            }
        });
    }
}

